class UserService extends BaseService
	@register()
	@inject 'UserInformation',
		'AuthenticationService'
		'MasterUserRepository'

	resetPassword: (userId) ->
		@MasterUserRepository.resetPassword(userId)

	updatePassword: (passwordData) ->
		@MasterUserRepository
			.updatePassword(@UserInformation.getMasterUser().id, passwordData)
			.then =>
				@reLogin(passwordData.new_password)

	reLogin: (password) ->
		user = @UserInformation.getSubUser()

		email = if user then user.email else @UserInformation.getMasterUser().email
		identifier = if user then @UserInformation.getMasterUser().email else null

		@AuthenticationService.login {username: email, password: password, identifier: identifier}
